import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "load-page tw-w-full tw-h-screen tw-flex tw-justify-center tw-items-center tw-bg-gray-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tw-relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spin" }),
  /*#__PURE__*/_createElementVNode("h3", { class: "texto-loader tw-absolute tw-text-xl tw-top-1/2 tw-left-1/2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cargando...")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}